module.exports = __webpack_public_path__ + "img/01-T.16a98262.png";